module.exports = __webpack_public_path__ + "static/media/k_of_spades2.249cc078.png";